// extracted by mini-css-extract-plugin
export default {"constructor_list":"constructor-item_constructor_list__8XKaK","icon_box":"constructor-item_icon_box__33bB-","element_box":"constructor-item_element_box__pU4rl"};